/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum MetaDataType {
    AudioMetaData = 1,
    VideoMetaData = 2,
    ImageMetaData = 3,
    ExternalFileMetaData = 4,
}
